import { useState, useEffect } from 'react';
import { InputDinamycPlaceholder } from '@lk-gtcom/ecomlab-components';
import { KonstantinAccountInSettingsHttps } from '../../fetchUrls';
import { ModalSuccessful } from '../Modal/ModalSuccessful/ModalSuccessful';
import { TitlePage } from '../TitlePage/TitlePage';
import Cookies from 'universal-cookie';
import './AccountSafety.scss';

const AccountSafety = ({
  changePassword,
  setChangePassword,
  setShowModalPasswordRecovery,
  setIsFormValid,
}) => {
  const [password, setPassword] = useState('');
  const [passwordRepeat, setPasswordRepeat] = useState('');
  const [newPassword, setNewPassword] = useState('');

  const [errPassword, setErrPassword] = useState(false);
  const [errPasswordRepeat, setErrPasswordRepeat] = useState(false);
  const [errNewPassword, setErrNewPassword] = useState(false);
  const [isModal, setIsModal] = useState(false);

  const auth = new Cookies().get('auth');
  const device_info = window.navigator.userAgent;

  const regexPassword =
    /(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z!@#$%^&*]{8,}/;

  const validateForm = (pass, newPass, repeatPass) => {
    const allFieldsValid =
      regexPassword.test(pass) &&
      regexPassword.test(newPass) &&
      regexPassword.test(repeatPass) &&
      newPass === repeatPass;
    setIsFormValid(allFieldsValid);
  };

  const handlerPassword = (e) => {
    const value = e;
    setPassword(value);
    validateForm(value, newPassword, passwordRepeat);
  };

  const handlerNewPassword = (e) => {
    const value = e;
    setNewPassword(value);
    validateForm(password, value, passwordRepeat);
  };

  const handlerPasswordRepeat = (e) => {
    const value = e;
    setPasswordRepeat(value);
    validateForm(password, newPassword, value);
  };

  const handleBlurPassword = () => {
    setErrPassword(password !== '' && !regexPassword.test(password));
  };

  const handleBlurNewPassword = () => {
    setErrNewPassword(newPassword !== '' && !regexPassword.test(newPassword));
  };

  const handleBlurPasswordRepeat = () => {
    setErrPasswordRepeat(
      passwordRepeat !== '' &&
      (!regexPassword.test(passwordRepeat) || passwordRepeat !== newPassword)
    );
  };

  const fetchChangePassword = () => {
    const url = `${KonstantinAccountInSettingsHttps}/web/change-password`;

    const body = JSON.stringify({
      old_password: password,
      new_password: newPassword,
      device_info: device_info,
    });

    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${auth}`,
    };

    fetch(url, { body, method: 'POST', headers })
      .then((res) =>
        res.json().then((json) => {
          const {
            access_token,
            client_id,
            login,
            not_one_account,
            refresh_token,
          } = json;
          const cookies = new Cookies();
          let d = new Date();
          let d2 = new Date();
          d.setTime(d.getTime() + 1000 * 60 * 60 * 24);
          d2.setTime(d.getTime() + 1000 * 60 * 60 * 24 * 7);

          if (login) {
            localStorage.setItem('email', login);
          }
          if (client_id) {
            localStorage.setItem('client_id', client_id);
          }
          if (not_one_account !== 'undefined') {
            localStorage.setItem('not_one_account', not_one_account);
          }
          if (access_token) {
            cookies.set('auth', access_token, { expires: d });
          }
          if (refresh_token) {
            cookies.set('refresh', refresh_token, { expires: d2 });
          }
          setIsModal(true);
        })
      )
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    if (changePassword) {
      const allFieldsValid =
        regexPassword.test(password) &&
        regexPassword.test(newPassword) &&
        regexPassword.test(passwordRepeat) &&
        newPassword === passwordRepeat;

      if (allFieldsValid) {
        fetchChangePassword();
      } else {
        if (!regexPassword.test(password)) setErrPassword(true);
        if (!regexPassword.test(newPassword)) setErrNewPassword(true);
        if (
          !regexPassword.test(passwordRepeat) ||
          newPassword !== passwordRepeat
        ) {
          setErrPasswordRepeat(true);
        }
      }
      setChangePassword(false);
    }
  }, [changePassword]);

  return (
    <>
      {isModal && 
        <ModalSuccessful
          title="Пароль успешно изменен"
          setIsModal={setIsModal}
        />
      }

      <form className="account-safety">
        <TitlePage
          medium
          title='Изменение пароля'
        />

        <div style={{ marginTop: '28px' }}>
          <InputDinamycPlaceholder
            onChange={(e) => handlerPassword(e)}
            onBlur={handleBlurPassword}
            type="password"
            err={errPassword}
            textErr={'Пароль должен содержать не менее 8 символов, цифры и заглавные буквы'}
            placeholder="Старый пароль"
            autoComplete={false}
            style={{ marginTop: '28px' }}
            tooltipStatic={
              !errPassword &&
              'Пароль должен содержать не менее 8 символов, цифры и заглавные буквы'
            }
          />
          <a
            href="#"
            className="account-safety__link-blue"
            onClick={(e) => {
              e.preventDefault(e);
              setShowModalPasswordRecovery(true);
            }}
          >
            Забыли пароль?
          </a>
        </div>

        <div style={{ marginTop: '11px' }}>
          <InputDinamycPlaceholder
            onChange={(e) => handlerNewPassword(e)}
            onBlur={handleBlurNewPassword}
            type="password"
            err={errNewPassword}
            textErr={'Пароль должен содержать не менее 8 символов, цифры и заглавные буквы'}
            placeholder="Новый пароль"
            autoComplete={false}
            tooltipStatic={
              !errNewPassword &&
              'Пароль должен содержать не менее 8 символов, цифры и заглавные буквы'
            }
          />
        </div>

        <div style={{ marginTop: '15px' }}>
          <InputDinamycPlaceholder
            onChange={(e) => handlerPasswordRepeat(e)}
            onBlur={handleBlurPasswordRepeat}
            type="password"
            err={errPasswordRepeat}
            textErr={'Пароль должен содержать не менее 8 символов, цифры и заглавные буквы или пароли не совпадают'}
            placeholder="Подтвердите новый пароль"
            autoComplete={false}
            tooltipStatic={
              !errPasswordRepeat &&
              'Пароль должен содержать не менее 8 символов, цифры и заглавные буквы'
            }
          />
        </div>
      </form>
    </>
  );
};

export { AccountSafety };
